import Stream from '../libs/Stream';
import {Step} from '../types/structure';


let openStepActionStream: Stream<Step> = new Stream() as Stream<Step>;

export default openStepActionStream;
